import {
  getContent,
  mergeContent,
  newScreen,
  closeScreen,
  mergeScreenState,
  newModal,
  closeModal,
} from "@js/helpers/state.js";

import {
  normalizeImages,
  denormalizeImages,
} from "@js/helpers/image_normalization.js";

import {
  CE_SCREEN_EDITOR_OPEN,
  CE_SCREEN_EDITOR_SAVE,
  CE_SCREEN_EDITOR_WARN_BEFORE_CANCEL,
  CE_SCREEN_EDITOR_ABORT_CANCELLATION,
  CE_SCREEN_EDITOR_CANCEL,
  CE_SCREEN_EDITOR_MARK_AS_DIRTY,
  CE_SCREEN_EDITOR_MARK_AS_CLEAN,
} from "@js/actions/studio/campaign_content_section/screen_editor.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_SCREEN_EDITOR_OPEN: {
      let content = getContent(state, action.client_content_id);

      return newScreen(state, "content_editor", {
        format: action.format,
        client_content_id: action.client_content_id,
        active_html_editor:
          action.format === "html" ? content.active_html_editor : "textarea",
        bee_json: content.bee_json || defaultBeeJson,
        html: denormalizeImages(state.campaign_id, content.html),
        text: content.text,
        subject: content.subject,
        organization_id: state.organization_id,
        mailing_list_id: state.mailing_list_id,
        mailing_lists: state.mailing_lists,
        bee_session_override: state.bee_session_override,
      });
    }

    case CE_SCREEN_EDITOR_WARN_BEFORE_CANCEL: {
      return newModal(state, "warn_before_screen_close", {
        title: t(
          `phrases.react_content.screen_editor_cancellation_warning.title`,
        ),
        save_action: {
          type: CE_SCREEN_EDITOR_CANCEL,
        },
        save_text: t(
          `phrases.react_content.screen_editor_cancellation_warning.confirm_text`,
        ),
        dangerous: true,
        cancel_action: {
          type: CE_SCREEN_EDITOR_ABORT_CANCELLATION,
        },
        cancel_text: t(
          `phrases.react_content.screen_editor_cancellation_warning.cancel_text`,
        ),
        warning: t(
          `phrases.react_content.screen_editor_cancellation_warning.warning`,
        ),
      });
    }

    case CE_SCREEN_EDITOR_ABORT_CANCELLATION: {
      return closeModal(state);
    }

    case CE_SCREEN_EDITOR_CANCEL: {
      return closeModal(closeScreen(state));
    }

    case CE_SCREEN_EDITOR_SAVE:
      let { format, client_content_id } = state.screen.state;

      // Close the warning modal if it's open
      let stateAfterClosingModal = closeModal(state);

      switch (format) {
        case "text":
          return mergeContent(
            closeScreen(stateAfterClosingModal),
            client_content_id,
            {
              text: action.text,
            },
          );
        case "html":
          return mergeContent(
            closeScreen(stateAfterClosingModal),
            client_content_id,
            {
              bee_json: action.bee_json,
              html: normalizeImages(state.campaign_id, action.html),
            },
          );
        default:
          return closeScreen(stateAfterClosingModal);
      }

    default:
      return state;
  }
};

//Seeding Bee with an empty JS object instead of this template will cause it to appear loading forever
const defaultBeeJson = JSON.stringify({
  page: {
    body: {
      content: {
        style: {
          color: "#000000",
          "font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
        },
        computedStyle: {
          messageBackgroundColor: "transparent",
          linkColor: "#0000FF",
          messageWidth: "900px",
        },
      },
      container: {
        style: {
          "background-color": "#FFFFFF",
        },
      },
      type: "mailup-bee-page-properties",
      webFonts: [
        {
          name: "Montserrat",
          fontFamily:
            "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
          url: "https://fonts.googleapis.com/css?family=Montserrat",
        },
      ],
    },
    rows: [
      {
        type: "one-column-empty",
        container: {
          style: {
            "background-color": "transparent",
            "background-image": "none",
            "background-repeat": "no-repeat",
            "background-position": "top left",
          },
        },
        content: {
          style: {
            "background-color": "transparent",
            color: "#000000",
            width: "675px",
            "background-image": "none",
            "background-repeat": "no-repeat",
            "background-position": "top left",
          },
          computedStyle: {
            rowColStackOnMobile: true,
          },
        },
        columns: [
          {
            "grid-columns": 12,
            modules: [
              {
                type: "mailup-bee-newsletter-modules-empty",
                descriptor: {},
              },
            ],
            style: {
              "background-color": "transparent",
              "padding-top": "5px",
              "padding-right": "0px",
              "padding-bottom": "5px",
              "padding-left": "0px",
              "border-top": "0px solid transparent",
              "border-right": "0px solid transparent",
              "border-bottom": "0px solid transparent",
              "border-left": "0px solid transparent",
            },
          },
        ],
      },
    ],
    description: "Empty Bee Template",
    template: {
      version: "2.0.0",
      type: "basic",
      name: "template-base",
    },
    title: "Empty Bee Template",
  },
});
